import { render } from "./EduManagementView.vue?vue&type=template&id=3cefc914&scoped=true"
import script from "./EduManagementView.vue?vue&type=script&lang=js"
export * from "./EduManagementView.vue?vue&type=script&lang=js"

import "./EduManagementView.vue?vue&type=style&index=0&id=3cefc914&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cefc914"]])

export default __exports__